import React from 'react';
import { RecommendedApps } from './recommended-apps';
import { EmptyStateDivider } from './empty-state-divider';
import { AddAppBox } from './add-app-box';
import { composer } from '../../component-decorators/composer';
import s from './empty-state.scss';
import { Button, Page } from 'wix-style-react';
import { sendAddAppBi } from '../../bi/biEvents';
export var EmptyState = composer()
    .withTranslation()
    .compose(function (_a) {
    var baseUrl = _a.baseUrl, msid = _a.msid, locale = _a.locale, gotoWebSolutionPage = _a.gotoWebSolutionPage, goToHomePage = _a.goToHomePage, origin = _a.origin, t = _a.t, editorType = _a.editorType, authorizationHeader = _a.authorizationHeader;
    return (React.createElement(Page, { height: '100%' },
        React.createElement(Page.Header, { title: t('manage-apps.page.title'), className: s.emptyStateTitle, actionsBar: React.createElement(Button, { onClick: function () {
                    sendAddAppBi(origin, msid, editorType);
                    goToHomePage();
                } }, t('manage-apps.empty-state.go-to-app-market')) }),
        React.createElement(Page.Content, null,
            React.createElement(AddAppBox, { origin: origin, msid: msid, goToHomePage: goToHomePage, editorType: editorType }),
            React.createElement(EmptyStateDivider, null),
            React.createElement(RecommendedApps, { baseUrl: baseUrl, authorizationHeader: authorizationHeader, locale: locale, origin: origin, gotoWebSolutionPage: gotoWebSolutionPage, editorType: editorType, msid: msid }))));
});
//# sourceMappingURL=empty-state.js.map